import { useState } from "react";
import { Megaphone, CheckCircle2, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { PageHeader, Card, Badge, Button } from "../components/ui";

function Announcements() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const canSeeWifi = user.role === "admin" || user.modules.includes("wifi");

  const [data, setData] = useState([
    {
      id: 1,
      author: "IT Administrator",
      subject: "WiFi Networks Update",
      message:
        "The new routers are installed and configured successfully. Please refer to the WiFi Passwords section for the latest network credentials.",
      status: "active",
      date: "12 Aug 2026",
    },
  ]);

  const markResolved = (id) =>
    setData((rows) => rows.map((r) => (r.id === id ? { ...r, status: "resolved" } : r)));

  return (
    <div className="space-y-6">
      <PageHeader
        title="Company Announcements"
        subtitle="Company news, IT updates and important notifications."
      />

      {data.map((item) => (
        <Card key={item.id} padded={false}>
          <div className="p-5 flex items-start justify-between gap-4">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center shrink-0">
                <Megaphone size={18} className="text-[#C00000]" />
              </div>
              <div>
                <h2 className="font-semibold text-[#111111]">{item.subject}</h2>
                <p className="text-xs text-gray-500 mt-0.5">
                  {item.author} · {item.date}
                </p>
              </div>
            </div>
            <Badge tone={item.status === "active" ? "brand" : "good"}>
              {item.status === "active" ? "Active" : "Resolved"}
            </Badge>
          </div>

          <div className="px-5 pb-5">
            <p className="text-sm text-gray-700 leading-relaxed">{item.message}</p>

            {canSeeWifi && (
              <button
                onClick={() => navigate("/dashboard/wifi")}
                className="mt-4 w-full flex items-center justify-between px-4 py-3 rounded-lg border border-gray-200 hover:border-[#C00000]/40 hover:bg-red-50/40 transition-colors text-left"
              >
                <span>
                  <span className="block text-sm font-medium text-[#111111]">WiFi Passwords</span>
                  <span className="block text-xs text-gray-500">View latest network credentials</span>
                </span>
                <ArrowRight size={16} className="text-[#C00000]" />
              </button>
            )}

            {item.status === "active" && (
              <div className="mt-5 flex justify-end">
                <Button variant="outline" onClick={() => markResolved(item.id)}>
                  <CheckCircle2 size={16} /> Mark as resolved
                </Button>
              </div>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
}

export default Announcements;
